import { BaseService } from "core/services";
import NikoPatientTemplateRouteService from "./NikoPatientTemplateRouteService";
class NikoPatientTemplateService extends BaseService {
  constructor(apiClient) {
    super(apiClient, new NikoPatientTemplateRouteService());
  }

  put(url, resource) {
    const connectionId = sessionStorage.getItem("connectionId");
    return this.apiClient.put(url, resource, connectionId ? { connectionId: connectionId } : null);
  }

  find(params) {
    const url = this.routeService.find(params);
    return this.apiClient.get(url);
  }

  post(url, resource) {
    const connectionId = sessionStorage.getItem("connectionId");
    return this.apiClient.post(url, resource, connectionId ? { connectionId: connectionId } : null);
  }

  get(id, options) {
    const url = this.routeService.get(id, options);
    return this.apiClient.get(url);
  }

  create(resource) {
    const url = this.routeService.create();
    return this.apiClient.post(url, resource);
  }

  updateMissingProductNote(resource) {
    let url = `${this.routeService.base}/${resource.id}/update-missing-product-note`;

    if (resource.missingProductNote && resource.missingProductNote.trim()) {
      url += `?missingProductNote=${encodeURIComponent(resource.missingProductNote)}`;
    }

    return this.put(url, resource);
  }

  updateInvoiceNote(resource) {
    let url = `${this.routeService.base}/${resource.id}/update-invoice-note`;

    if (resource.invoiceNote && resource.invoiceNote.trim()) {
      url += `?invoiceNote=${encodeURIComponent(resource.invoiceNote)}`;
    }

    return this.put(url, resource);
  }

  updateMissingDocumentNote(resource) {
    const url = this.routeService.updateMissingDocumentNote(resource);
    return this.apiClient.put(url, resource);
  }

  updateClinicalStatusNote(resource) {
    const url = this.routeService.updateClinicalStatusNote(resource);
    return this.apiClient.put(url, resource);
  }

  updateClinicalStatus(resource) {
    const url = this.routeService.updateClinicalStatus(resource);
    return this.apiClient.put(url, resource);
  }

  changeClinicalStatus(resource) {
    const url = this.routeService.changeClinicalStatus(resource);
    return this.apiClient.put(url, resource);
  }

  hasLinkedInvoice(id) {
    const url = this.routeService.hasLinkedInvoice(id);
    return this.apiClient.get(url);
  }

  findMultiDosCreditCandidates(id) {
    const url = this.routeService.findMultiDosCreditCandidates(id);
    return this.apiClient.get(url);
  }

  // ISG-2723 (part of ISG-2474): confirm a multi-DOS credit - credits the source PSO, then copies its clinical fields
  // onto every checked candidate PSO and credits each of those too.
  applyMultiDosCredit(resource) {
    const url = this.routeService.applyMultiDosCredit(resource);
    return this.apiClient.post(url, resource);
  }

  updateDiscontinuedStatus(resource) {
    const url = this.routeService.updateDiscontinuedStatus(resource);
    return this.apiClient.put(url, resource);
  }

  getMedicalNecessityFormReportUrl(id) {
    const url = this.routeService.getMedicalNecessityFormReportUrl(id);
    return this.apiClient.appOptions.apiUrl + url;
  }

  getStandardWrittenOrderReportUrl(id) {
    const url = this.routeService.getStandardWrittenOrderReportUrl(id);
    return this.apiClient.appOptions.apiUrl + url;
  }

  updateCustomOrderingDoctor(resource) {
    const url = this.routeService.updateCustomOrderingDoctor(resource);
    const connectionId = sessionStorage.getItem("connectionId");
    return this.apiClient.put(url, resource, connectionId ? { connectionId: connectionId } : null);
  }

  updateClinicalInformation(resource) {
    const url = this.routeService.updateClinicalInformation(resource);
    const connectionId = sessionStorage.getItem("connectionId");
    return this.apiClient.put(url, resource, connectionId ? { connectionId: connectionId } : null);
  }

  deleteNewTemplate(id) {
    const url = this.routeService.deleteNewTemplate(id);
    // const connectionId = sessionStorage.getItem("connectionId");
    return this.apiClient.delete(url);//, connectionId ? { connectionId: connectionId} : null);
  }

  findReplacementItems(filter) {
    const url = this.routeService.findReplacementItems(filter);
    return this.apiClient.get(url);
  }

  createNikoMasterPatientTemplateBySubCategory(request) {
    const url = this.routeService.createNikoMasterPatientTemplateBySubCategory();
    return this.post(url, request);
  }

  reviewPatientTemplate(resources) {
    const url = this.routeService.reviewPatientTemplate(resources);
    const connectionId = sessionStorage.getItem("connectionId");
    return this.apiClient.put(url, resources, connectionId ? { connectionId: connectionId } : null);
  }

  // ISG-871: runs drainage bag / leg bag validations on the given templates and returns warning messages.
  drainageBagValidation(ids) {
    const url = this.routeService.drainageBagValidation();
    const connectionId = sessionStorage.getItem("connectionId");
    return this.apiClient.put(url, ids, connectionId ? { connectionId: connectionId } : null);
  }

  // Returns Niko invoice ids ({ remoteId, displayId }) per template, for the CR/PSO template headers.
  getNikoInvoiceIds(ids) {
    const url = this.routeService.getNikoInvoiceIds();
    return this.apiClient.post(url, ids);
  }

  nikoProcess(resource) {
    const url = this.routeService.nikoProcess(resource);
    return this.post(url, resource);
  }

  nikoInvoice(resource) {
    const url = this.routeService.nikoInvoice(resource);
    return this.post(url, resource);
  }

  createMonthlyTubeMasterTemplates(facilityOrderId) {
    const url = this.routeService.createMonthlyTubeMasterTemplates(facilityOrderId);
    return this.apiClient.post(url, {});
  }

  checkSystemDns(filter) {
    const url = this.routeService.checkSystemDns(filter);
    return this.apiClient.get(url);
  }

  getAvailableBillingValidations(filter) {
    const url = this.routeService.getAvailableBillingValidations(filter);
    return this.apiClient.get(url);
  }
}

export default NikoPatientTemplateService;

